export default "/8522fe2631ecefb1e3967be9883671f05392a386/062e30a7ac6b62636e98a277a6442dbf.svg";